import {
  Departamento,
  FormActionType,
  Pais
} from '@rpe/registro-personas-empresas-lib';
import { DireccionGeograficaIDE } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.model';
import { Localidad } from '../entity-localidades/entity-localidades.model';

export interface DireccionGeografica {
  id: number;
  pais_codigo: string;
  departamento_codigo: string;
  localidad_id: number;
  localidad_nombre: string;
  codigo_postal: number;
  direccion: string;
  longitud: number;
  latitud: number;
}

export function createEmptyDireccionGeografica(): DireccionGeografica {
  return {
    id: null,
    pais_codigo: null, // codigo Pais
    departamento_codigo: null, // codigo Departamento
    localidad_id: null, // id Localidad
    localidad_nombre: null,
    codigo_postal: null,
    direccion: null,
    longitud: null,
    latitud: null
  };
}

// form
export interface DireccionGeograficaFormInput {
  action: FormActionType;
  direccion_geografica: DireccionGeografica;
  direcciones_geografica_IDE: DireccionGeograficaIDE[];
  paises: Pais[];
  departamentos: Departamento[];
  localidades: Localidad[];
}
